import React        from 'react';
import { Link }     from 'react-router-dom';
import { getRoute } from 'pursuit/routes/routes';

export default function AboutUs() {
    return (
        <section role="main" className="about-us">
            <h2 className="content-title justify-center minor-margin--bottom">Pursuit Integrative Health</h2>

            <div className="grid-center">
                <div className="col-4_xs-11_md-4">
                    <div className="section-title text-large highlight">
                        Our Mission
                    </div>
                    <p>Our mission at Pursuit Integrative Health is to serve our community's healthcare needs, as well as guide our patients toward the achievement of optimal health.</p>
                </div>
                <div className="col-7_xs-11_md-7">
                    <div className="section-title text-large highlight">
                        About Us
                    </div>
                    <p>At Pursuit Integrative Health we strive to provide high quality health care that fits the needs of our surrounding community.</p>

                    <p>You will find a welcoming and warm environment at PIH from the moment you walk into our beautiful new space. The main goal with our patients is to not only alleviate any aches and pains, but to also empower them to be an active participant in their own health and well-being.</p>

                    <p>We are a multi-disciplinary clinic that strives to offer collaborative care in an effort to best take care of our patients and athletes. We currently offer chiropractic care, acupuncture, massage therapy, nutritional counselling, personal training and we are looking to continue to grow based on the needs of our patients. Additionally, our clinic offers group Pilates and Yoga classes, as well as private rehabilitative exercise sessions.</p>

                    <p>At Pursuit we believe active care and quality movement is a big part of maintaining health. All of our practitioners are well equipped to provide you the right exercises to assist with your injury recovery, improve your sport performance, or just help you function better.</p>

                    <p>We encourage you to always be in constant <span className="bold">Pursuit</span> of healthy living. <Link to={getRoute('contact')} className="highlight">Let us know</Link> how we can help!</p>
                </div>
            </div>

            <div className="grid-center">
            </div>
            <div className="grid-center">
                <div className="col-7_xs-11_md-9">
                </div>
            </div>
        </section>
    );
};
